import { calculateExpiredDate } from './Cookies';
import RegisterExperiment from '../Experiment/RegisterExperiment';
import RegisterMultipleExperiments from '../Experiment/RegisterMultipleExperiments';
import { Experiments, ProviderDefaults, ServerCookies } from '../SharedTypes';
import { getIdentifierFromAuthToken } from '../utilities';

type FetchExperimentResponse = {
  experiments: Experiments;
  cookies: string[];
};

const FetchExperimentData = async (experiments: Experiments, settings: ProviderDefaults = {}, serverCookies: ServerCookies = {}) => {
  const experimentKeys = Object.keys(experiments);
  const response: FetchExperimentResponse = {
    experiments: {},
    cookies: []
  };

  const updateResponse = (name, updatedExperiments, shouldSetCookie = true) => {
    const { assignedBucket, hasErrored } = updatedExperiments[name];
    const { cacheMinutes = 15 } = settings;
    const cookieExpire = calculateExpiredDate(cacheMinutes);

    if (hasErrored || !assignedBucket) return;

    if (shouldSetCookie && assignedBucket && cacheMinutes > 0) {
      response.cookies.push(`${name}=${assignedBucket}${cookieExpire}; path=/`);
    }

    response.experiments[name] = updatedExperiments[name];
  };

  const { identifier } = settings;
  const identifierToUse = identifier || getIdentifierFromAuthToken();
  if (!identifierToUse) {
    const registeredExperiments = await Promise.all(experimentKeys.map(name => {
      const { defaultBucket = 'control' } = experiments[name];
      return RegisterExperiment({
        ...settings,
        name,
        experiments: response.experiments,
        defaultBucket,
        serverCookies
      }, updateResponse);
    })).then(() => response);
    return registeredExperiments;
  }

  const experimentsToRegister = Object.keys(experiments).map(name => {
    const { defaultBucket = 'control' } = experiments[name];
    return {
      experimentName: name,
      defaultBucket
    };
  });

  return RegisterMultipleExperiments({
    ...settings,
    identifier: identifierToUse,
    experimentsToRegister,
    experiments: response.experiments,
    serverCookies
  }, updateResponse).then(() => response);
};

export default FetchExperimentData;
